import createTable from './CompanyDetailsTable';

export default createTable({
  namePrefix: 'targetMarkets',
  tableName: 'Markets',
  columns: [{ field: 'market' }, { field: 'percent', title: '%', className: 'text-right', type: 'number' }],
});
